import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1254.000000 1254.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1254.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M5870 10869 c-536 -60 -1032 -291 -1390 -649 -110 -109 -133 -135
-218 -247 -390 -513 -553 -1171 -446 -1797 29 -169 112 -449 146 -493 23 -30
257 -91 438 -114 105 -14 487 -15 590 -2 l64 8 -54 58 c-131 140 -259 357
-319 542 -78 238 -82 532 -12 783 182 652 775 1091 1475 1092 112 0 276 -20
381 -46 158 -40 381 -147 522 -251 117 -85 314 -284 369 -371 2 -3 73 38 287
162 351 205 419 244 424 250 14 14 -174 262 -277 365 -395 396 -830 616 -1375
697 -123 18 -489 26 -605 13z"
          />
          <path
            d="M7060 8446 l0 -306 58 26 c31 14 84 37 117 51 171 72 535 264 745
392 63 39 136 83 163 97 26 15 47 30 47 34 0 4 -254 8 -565 9 l-565 2 0 -305z"
          />
          <path
            d="M8420 8567 c-287 -214 -650 -438 -1030 -634 l-64 -33 112 0 c83 0
112 -3 112 -12 0 -18 -73 -150 -128 -232 -87 -129 -257 -292 -408 -388 -60
-38 -189 -101 -269 -131 -174 -65 -328 -91 -535 -91 -177 1 -304 19 -455 65
l-99 31 -111 -31 c-320 -89 -572 -133 -890 -156 -104 -8 -192 -14 -194 -15
-19 -2 199 -184 309 -256 406 -270 865 -404 1380 -404 764 0 1469 320 1902
865 239 300 392 671 442 1070 20 154 32 415 20 415 -5 0 -48 -28 -94 -63z"
          />
          <path
            d="M10453 5963 c-10 -4 -13 -184 -13 -854 l0 -849 220 0 220 0 0 855 0
855 -207 -1 c-115 0 -214 -3 -220 -6z"
          />
          <path
            d="M2425 5936 c-154 -26 -259 -65 -377 -141 -183 -119 -312 -296 -369
-510 -17 -63 -22 -108 -22 -215 0 -162 20 -248 87 -385 99 -201 273 -340 506
-406 77 -22 104 -24 285 -24 187 0 207 2 297 27 381 106 606 386 643 799 4 42
4 95 0 118 l-7 41 -438 0 -439 0 -6 -42 c-3 -24 -5 -101 -3 -173 l3 -130 208
-3 c114 -1 207 -6 207 -10 0 -20 -61 -101 -104 -139 -62 -55 -116 -80 -213
-100 -199 -41 -418 47 -511 205 -58 100 -78 257 -47 377 62 235 291 383 539
347 92 -13 196 -59 263 -116 22 -20 44 -36 46 -36 7 0 297 207 317 226 12 12
10 19 -20 50 -99 102 -257 190 -405 224 -116 27 -328 35 -440 16z"
          />
          <path
            d="M8658 5943 c-14 -2 -31 -10 -37 -17 -8 -9 -10 -254 -9 -822 l3 -809
465 0 c499 0 505 1 658 56 249 90 438 278 516 512 38 113 46 289 20 415 -34
165 -93 271 -224 402 -105 104 -163 143 -291 194 -160 65 -188 68 -654 71
-231 2 -432 1 -447 -2z m749 -383 c89 -12 196 -59 254 -112 88 -79 133 -192
133 -333 0 -214 -100 -360 -294 -427 -58 -20 -85 -23 -255 -23 l-190 0 -3 444
c-2 349 0 446 10 453 19 11 253 10 345 -2z"
          />
          <path
            d="M4107 5913 c-8 -16 -49 -107 -90 -203 -41 -96 -110 -254 -152 -350
-79 -179 -127 -290 -233 -535 -34 -77 -89 -203 -122 -280 -84 -193 -94 -220
-87 -239 6 -15 29 -16 223 -14 l217 3 32 75 c18 41 47 110 65 153 l32 77 343
0 343 0 22 -52 c12 -29 34 -78 48 -108 14 -30 33 -75 42 -100 l18 -45 223 -2
c123 -2 230 1 237 6 16 10 17 7 -168 416 -65 143 -161 357 -215 475 -53 118
-115 253 -137 300 -21 47 -76 166 -122 265 l-82 180 -212 3 -211 2 -14 -27z
m256 -545 c126 -304 177 -431 177 -439 0 -5 -87 -9 -205 -9 -136 0 -205 4
-205 10 0 6 34 97 76 203 107 274 117 297 124 297 4 0 19 -28 33 -62z"
          />
          <path
            d="M5368 5128 c2 -447 5 -819 7 -826 4 -10 130 -12 607 -10 l603 3 3
182 2 183 -392 2 -393 3 -1 135 c0 74 -1 361 -2 638 l-2 502 -218 0 -218 0 4
-812z"
          />
          <path
            d="M7374 5930 c-25 -10 -33 -25 -152 -305 -98 -228 -433 -1003 -487
-1125 -76 -173 -78 -179 -65 -195 11 -13 45 -15 227 -13 l214 3 40 95 c22 52
50 121 62 153 l21 57 349 -2 349 -3 67 -150 66 -150 230 0 230 0 -2 22 c-2 21
-43 113 -275 628 -50 110 -142 315 -205 455 -207 460 -226 500 -246 517 -17
16 -44 18 -211 20 -105 1 -201 -2 -212 -7z m226 -537 c50 -112 190 -453 190
-463 0 -6 -73 -10 -210 -10 -115 0 -210 2 -210 5 0 7 84 221 120 305 15 36 40
98 55 138 15 39 28 72 30 72 2 0 14 -21 25 -47z"
          />
          <path
            d="M3270 2593 c-44 -40 -50 -90 -17 -129 15 -18 44 -36 69 -43 90 -27
119 -56 86 -89 -17 -17 -90 -15 -116 4 -21 15 -25 15 -43 -2 -26 -23 -24 -37
9 -56 64 -37 156 -34 206 6 21 18 29 35 33 68 5 39 2 48 -23 73 -17 16 -58 37
-94 49 -44 14 -66 27 -68 39 -8 44 51 62 108 32 26 -14 29 -13 44 10 9 13 16
27 16 30 0 14 -74 35 -125 35 -46 0 -60 -5 -85 -27z"
          />
          <path
            d="M3800 2543 c-18 -43 -50 -120 -71 -172 -21 -52 -39 -98 -39 -103 0
-4 16 -8 36 -8 31 0 37 4 50 35 l14 35 81 0 80 0 15 -35 c13 -32 18 -35 54
-35 31 0 38 3 33 16 -3 8 -36 88 -73 177 l-68 162 -40 3 -40 3 -32 -78z m99
-78 c12 -31 21 -60 21 -66 0 -11 -88 -10 -95 1 -6 9 38 120 47 120 4 0 16 -25
27 -55z"
          />
          <path
            d="M4250 2596 c0 -13 3 -44 6 -70 6 -39 10 -46 29 -46 25 0 35 30 35
101 0 38 -1 39 -35 39 -30 0 -35 -3 -35 -24z"
          />
          <path
            d="M4660 2593 c-7 -16 -34 -80 -60 -143 -27 -63 -55 -132 -64 -152 l-16
-38 40 0 c36 0 41 3 54 35 l15 35 80 0 81 0 14 -35 c14 -32 19 -35 55 -35 l41
0 -26 58 c-14 31 -41 96 -59 144 -61 154 -64 158 -105 158 -30 0 -39 -5 -50
-27z m77 -130 c12 -31 20 -60 17 -64 -6 -10 -83 -9 -89 1 -6 10 34 120 43 120
4 0 17 -25 29 -57z"
          />
          <path
            d="M5372 2588 c3 -32 5 -33 48 -35 25 -1 50 -2 55 -2 6 -1 9 -54 7 -146
l-3 -145 40 0 41 0 0 145 0 144 58 3 c56 3 57 3 60 36 l3 32 -156 0 -156 0 3
-32z"
          />
          <path
            d="M5965 2588 c-7 -18 -41 -97 -74 -176 -34 -79 -61 -145 -61 -148 0 -2
18 -4 39 -4 36 0 41 3 52 35 l13 35 81 0 81 0 17 -35 c14 -30 21 -35 52 -35
19 0 35 3 35 8 0 4 -25 68 -56 142 -30 74 -62 152 -71 173 -14 34 -18 37 -55
37 -35 0 -41 -4 -53 -32z m82 -125 c12 -31 20 -60 17 -65 -5 -8 -82 -4 -91 6
-7 6 37 116 46 116 3 0 16 -26 28 -57z"
          />
          <path
            d="M6410 2440 l0 -180 41 0 41 0 -4 70 c-2 42 1 70 7 71 6 0 40 0 78 -1
l67 -1 0 35 0 36 -80 0 -81 0 3 40 2 40 72 0 c91 0 104 5 104 41 l0 29 -125 0
-125 0 0 -180z"
          />
          <path d="M6880 2440 l0 -180 40 0 40 0 0 180 0 180 -40 0 -40 0 0 -180z" />
          <path
            d="M7563 2593 c-23 -14 -51 -43 -62 -63 -26 -46 -28 -128 -4 -177 51
-109 226 -135 310 -46 30 31 33 40 33 94 l0 59 -85 0 -85 0 0 -30 c0 -29 2
-30 45 -30 41 0 45 -2 45 -25 0 -30 -43 -55 -95 -55 -26 0 -45 9 -71 33 -30
27 -36 39 -37 79 -2 57 24 97 77 117 34 13 42 12 86 -6 l49 -21 23 25 c19 20
20 26 8 34 -46 31 -75 39 -133 39 -51 0 -71 -5 -104 -27z"
          />
          <path
            d="M8102 2448 c-40 -95 -72 -176 -72 -180 0 -5 17 -8 38 -8 34 0 39 3
51 35 l12 35 83 0 82 0 13 -35 c11 -32 16 -35 52 -35 21 0 39 2 39 5 0 2 -31
78 -70 169 -38 90 -70 169 -70 175 0 6 -18 11 -43 11 l-42 0 -73 -172z m140
14 c27 -70 25 -74 -29 -70 -40 2 -47 6 -45 21 6 33 42 110 49 103 4 -4 15 -28
25 -54z"
          />
          <path
            d="M8560 2584 l0 -35 53 2 52 3 3 -147 3 -147 39 0 40 0 0 145 0 145 33
1 c17 1 37 2 42 4 6 1 16 3 23 3 6 1 12 15 12 32 l0 30 -150 0 -150 0 0 -36z"
          />
          <path
            d="M9130 2543 c-18 -43 -52 -124 -76 -180 l-43 -103 39 0 c36 0 41 3 54
35 l15 35 81 0 80 0 17 -35 c15 -31 21 -35 56 -35 27 0 38 4 34 13 -3 6 -26
62 -52 122 -25 61 -56 135 -69 165 -22 52 -25 55 -63 58 l-40 3 -33 -78z m99
-74 c13 -28 20 -57 17 -64 -6 -16 -91 -15 -91 0 0 18 39 115 46 115 3 0 16
-23 28 -51z"
          />
          <path
            d="M3380 1943 c-45 -17 -66 -68 -37 -91 7 -6 35 -19 62 -29 41 -15 50
-23 50 -42 0 -35 -44 -48 -87 -27 -39 20 -60 6 -27 -18 30 -20 88 -21 117 0
18 12 22 24 20 52 -3 35 -6 38 -60 55 -31 11 -59 25 -62 33 -15 39 34 62 80
38 32 -17 34 -17 34 -1 0 24 -56 43 -90 30z"
          />
          <path
            d="M6723 1936 c-71 -32 -83 -135 -22 -190 28 -25 38 -28 77 -23 29 3 53
13 69 29 28 29 40 90 24 130 -20 52 -92 79 -148 54z m107 -36 c27 -27 28 -110
3 -132 -69 -60 -163 -1 -143 89 5 19 17 41 27 48 27 22 89 19 113 -5z"
          />
          <path
            d="M7823 1935 c-96 -41 -74 -195 30 -212 73 -11 127 37 127 114 0 47
-22 81 -66 99 -41 17 -50 17 -91 -1z m99 -29 c41 -31 44 -108 6 -143 -30 -27
-95 -24 -119 6 -27 33 -26 104 3 131 25 23 84 27 110 6z"
          />
          <path
            d="M8958 1935 c-20 -11 -28 -23 -28 -44 0 -35 17 -50 78 -71 55 -18 65
-41 27 -66 -23 -15 -32 -16 -59 -5 -44 17 -48 17 -53 5 -5 -14 41 -34 80 -34
45 0 77 25 77 59 0 34 -22 54 -77 70 -48 13 -57 23 -48 51 5 15 15 20 44 20
20 0 42 -5 49 -12 6 -6 15 -8 19 -5 11 12 -20 36 -52 42 -18 3 -41 -1 -57 -10z"
          />
          <path
            d="M10344 1936 c-42 -19 -64 -52 -64 -99 0 -68 44 -117 106 -117 29 0
84 26 84 40 0 13 -3 13 -36 -5 -16 -8 -39 -15 -50 -15 -33 0 -73 37 -80 74 -7
38 15 90 41 100 26 10 83 7 90 -4 3 -5 14 -10 23 -10 14 0 14 3 -3 19 -27 26
-74 33 -111 17z"
          />
          <path
            d="M1860 1834 c-23 -58 -39 -108 -35 -112 8 -8 35 26 35 45 0 8 13 13
30 14 17 1 40 2 52 2 14 1 27 -8 37 -27 14 -25 25 -33 33 -23 2 1 -15 48 -37
104 -28 71 -45 103 -56 103 -11 0 -29 -32 -59 -106z m83 20 l16 -42 -31 -6
c-44 -9 -51 3 -31 57 19 52 23 51 46 -9z"
          />
          <path
            d="M2140 1830 l0 -111 68 3 c77 3 84 22 8 24 l-50 1 3 60 c1 34 -1 77
-4 97 -14 70 -25 35 -25 -74z"
          />
          <path
            d="M2374 1923 c2 -10 14 -55 26 -100 20 -74 42 -114 55 -101 3 3 16 42
29 87 13 45 26 85 29 87 3 3 14 -28 26 -68 41 -139 55 -138 92 1 16 58 27 107
24 109 -11 11 -25 -15 -40 -80 -10 -40 -21 -77 -26 -82 -4 -5 -19 30 -34 78
-17 57 -31 86 -41 86 -8 0 -17 -6 -19 -12 -2 -7 -14 -46 -26 -87 -25 -84 -30
-81 -56 27 -11 46 -22 72 -31 72 -8 0 -11 -7 -8 -17z"
          />
          <path
            d="M2795 1838 c-22 -57 -39 -104 -37 -105 8 -9 19 -3 29 18 10 19 22 25
64 29 51 6 52 5 66 -27 7 -18 18 -33 23 -33 15 0 13 6 -31 117 -29 71 -47 103
-58 103 -11 0 -28 -32 -56 -102z m82 20 c10 -24 15 -45 13 -48 -4 -4 -42 -5
-72 -1 -10 1 24 91 34 91 5 0 16 -19 25 -42z"
          />
          <path
            d="M3040 1935 c0 -2 15 -29 34 -58 25 -39 36 -68 38 -103 4 -61 19 -60
24 2 3 41 14 65 62 142 12 18 12 22 1 22 -8 0 -27 -20 -42 -45 -16 -25 -30
-45 -32 -45 -2 0 -18 20 -35 45 -26 38 -50 57 -50 40z"
          />
          <path
            d="M3811 1838 c-45 -112 -46 -118 -30 -118 5 0 15 14 20 30 10 28 14 30
64 30 49 0 55 -3 67 -27 11 -23 23 -31 30 -20 1 1 -16 48 -38 104 -27 72 -44
103 -55 103 -12 0 -29 -31 -58 -102z m80 17 l17 -45 -39 0 c-22 0 -39 2 -39 5
0 12 33 85 39 85 3 0 13 -20 22 -45z"
          />
          <path
            d="M4050 1934 c0 -16 83 -214 90 -214 14 0 27 23 60 110 18 47 35 91 37
98 3 6 -1 12 -8 12 -8 0 -27 -35 -44 -82 -16 -45 -35 -83 -40 -85 -6 -2 -23
35 -40 82 -16 48 -35 85 -42 85 -7 0 -13 -3 -13 -6z"
          />
          <path
            d="M4367 1840 c-21 -55 -38 -102 -38 -105 2 -16 17 -6 29 18 12 24 18
27 65 27 48 0 53 -3 71 -33 33 -57 27 -15 -13 88 -53 136 -64 137 -114 5z m87
-6 c6 -19 2 -22 -30 -26 -34 -4 -35 -3 -31 21 3 14 11 40 18 56 l11 30 13 -30
c7 -16 15 -40 19 -51z"
          />
          <path
            d="M4650 1830 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10
110 -6 0 -10 -43 -10 -110z"
          />
          <path
            d="M4826 1909 c-8 -40 -8 -137 0 -166 6 -21 12 -23 70 -23 52 0 64 3 64
16 0 12 -10 15 -52 13 l-53 -3 -3 97 c-3 97 -14 125 -26 66z"
          />
          <path
            d="M5122 1888 c-11 -29 -29 -76 -41 -105 -13 -33 -17 -54 -10 -59 5 -3
15 8 22 25 11 29 14 31 64 31 48 0 54 -2 68 -30 9 -17 20 -28 25 -25 6 4 5 17
-4 33 -7 15 -26 62 -41 105 -35 96 -54 102 -83 25z m56 -15 c5 -16 13 -36 17
-45 6 -16 1 -18 -35 -18 -36 0 -41 2 -35 18 4 9 12 29 17 45 5 15 14 27 18 27
4 0 13 -12 18 -27z"
          />
          <path
            d="M5382 1833 l3 -108 65 2 c48 1 68 6 77 19 18 24 16 54 -4 76 -13 14
-14 21 -5 30 17 17 15 54 -4 72 -10 11 -34 16 -75 16 l-60 0 3 -107z m113 52
c0 -29 -2 -30 -45 -30 -41 0 -45 2 -46 25 -1 37 4 41 49 38 39 -3 42 -5 42
-33z m-12 -64 c29 -11 42 -38 27 -56 -6 -7 -31 -15 -55 -17 -42 -3 -43 -2 -47
28 -2 18 -2 37 0 43 4 13 42 14 75 2z"
          />
          <path
            d="M5680 1830 l0 -111 68 3 c78 3 84 22 7 24 l-50 1 -3 96 c-4 135 -22
124 -22 -13z"
          />
          <path
            d="M5940 1830 l0 -111 73 3 c86 4 93 23 9 24 l-57 1 0 39 0 39 58 3 c73
4 66 22 -9 22 l-54 0 0 35 0 35 60 0 c33 0 60 4 60 10 0 6 -30 10 -70 10 l-70
0 0 -110z"
          />
          <path
            d="M6400 1830 c0 -112 16 -155 22 -57 l3 52 49 1 c72 1 73 24 2 24 l-56
0 0 35 0 35 60 0 c33 0 60 4 60 10 0 6 -30 10 -70 10 l-70 0 0 -110z"
          />
          <path
            d="M7020 1830 c0 -62 4 -110 9 -110 6 0 11 21 13 48 3 43 5 47 30 50 22
3 32 -4 55 -40 15 -24 32 -46 37 -50 18 -12 28 4 13 20 -35 41 -39 61 -18 89
48 59 13 103 -81 103 l-58 0 0 -110z m129 68 c15 -40 -4 -58 -59 -58 l-50 0 0
40 0 40 50 0 c43 0 52 -3 59 -22z"
          />
          <path
            d="M7480 1934 c0 -3 14 -27 32 -53 23 -32 34 -62 38 -99 3 -29 10 -53
15 -53 6 0 12 24 15 53 4 38 14 66 38 100 34 50 37 58 22 58 -5 0 -23 -20 -40
-45 -17 -25 -34 -45 -38 -45 -4 0 -19 21 -34 45 -23 39 -48 59 -48 39z"
          />
          <path
            d="M8120 1855 c0 -78 2 -88 25 -110 35 -36 97 -35 130 1 22 24 25 36 25
110 0 67 -3 84 -15 84 -11 0 -15 -19 -17 -87 -3 -82 -5 -88 -29 -102 -22 -12
-29 -12 -55 0 -28 14 -29 16 -32 102 -2 68 -6 87 -17 87 -12 0 -15 -17 -15
-85z"
          />
          <path
            d="M8450 1829 c0 -84 3 -110 13 -107 6 3 13 25 15 51 3 42 6 47 28 47
17 0 34 -13 60 -50 42 -59 65 -58 28 2 l-26 40 21 22 c12 12 21 34 21 48 0 41
-29 58 -98 58 l-62 0 0 -111z m124 75 c19 -18 19 -20 6 -45 -8 -14 -21 -19
-54 -19 -48 0 -60 14 -50 56 5 20 12 24 44 24 22 0 45 -7 54 -16z"
          />
          <path
            d="M9222 1833 l3 -108 68 0 c85 0 93 19 9 23 l-62 3 5 31 c8 46 11 48
66 48 31 0 48 4 44 10 -3 6 -28 10 -55 10 -54 0 -64 7 -54 45 6 23 10 25 65
25 33 0 59 4 59 10 0 6 -32 10 -75 10 l-76 0 3 -107z"
          />
          <path
            d="M9512 1833 c2 -66 7 -107 13 -106 6 2 11 15 11 30 1 16 2 36 3 46 1
11 9 17 25 17 23 0 32 -8 86 -80 30 -40 34 -16 5 30 l-27 42 21 22 c12 12 21
34 21 48 0 41 -29 58 -99 58 l-62 0 3 -107z m132 65 c19 -30 -4 -53 -58 -56
-32 -2 -46 1 -47 10 -1 7 -2 26 -3 41 -3 28 -2 28 47 25 34 -2 53 -8 61 -20z"
          />
          <path
            d="M9794 1924 c4 -11 21 -57 38 -104 17 -47 35 -89 39 -95 15 -15 34 14
67 100 16 44 33 88 37 98 5 11 3 17 -6 17 -8 0 -28 -38 -48 -90 -19 -50 -37
-88 -39 -85 -3 3 -20 42 -37 87 -18 45 -38 84 -45 86 -9 3 -11 -1 -6 -14z"
          />
          <path
            d="M10110 1830 c0 -67 4 -110 10 -110 6 0 10 43 10 110 0 67 -4 110 -10
110 -6 0 -10 -43 -10 -110z"
          />
          <path
            d="M10610 1830 l0 -111 73 3 c85 4 93 22 12 26 l-55 3 0 39 0 40 50 0
c66 0 64 18 -2 22 -51 3 -53 4 -53 33 0 30 1 30 58 33 81 4 71 22 -13 22 l-70
0 0 -110z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
